// ======> Levi Eiko Designs | 'Type in Text' Animation
// ==========================> May 2024

// ==> Adjust these 5 parameters
// ========> Speeds in Miliseconds (ms)
// ========> Pause multiple of Delay Rate
const elementId = "animate-about-hero-text";
const delayStart = 600;
const delayRate = 140;
const delayPause = 4;
const transitionRate = 200;

// ==> Animation functions
let delayTyping = 0;

prepTypeInText = (() => {
  
  const getTextEl = document.getElementById(`${elementId}`);
  const textString = getTextEl.innerText;
  const letterArray = textString.split("");
  
        getTextEl.removeChild(getTextEl.firstChild);
  
  const mapLetterArray = letterArray.map((letter, key) => {  
        const delaySpeed = delayTyping * delayRate;
        
        const createHeroContainer = document.createElement("span");
              createHeroContainer.classList.add("fade-in-letter");
              createHeroContainer.style.color = "rgb(255,255,255)";         
            if (letter == " ") {
              createHeroContainer.style.transition = `color ${transitionRate}ms linear ${delaySpeed}ms`;
              createHeroContainer.innerText = "\u00a0";
              delayTyping = ++delayTyping;
            } else if (letter == "," || letter == "." || letter == ":" || letter == ";"){
              createHeroContainer.style.transition = `color ${transitionRate}ms linear ${delaySpeed}ms`;
              createHeroContainer.innerText = letter;
              delayTyping = delayTyping + delayPause;
            } else {
              createHeroContainer.style.transition = `color ${transitionRate}ms linear ${delaySpeed}ms`;
              createHeroContainer.innerText = letter;
              delayTyping = ++delayTyping;
            }
        
        getTextEl.appendChild(createHeroContainer);
  });
});
prepTypeInText();

animateTypeInText = (() => {
  const getAboutFadeText = document.querySelectorAll(".fade-in-letter");
  const mapLetterArrayTwo = getAboutFadeText.forEach((letter) => {
    // letter.classList.remove('fade-in-letter');
    letter.style.color = 'rgb(0,0,0)';
  });  
});
setTimeout(animateTypeInText, delayStart);